// extracted by mini-css-extract-plugin
export default {"panel":"InfoMessage_panel__9-uhe","error":"InfoMessage_error__Nlkc5"};